/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("#slider").classList.add("active");
    document.querySelector('#sliderContent').classList.add('active');
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector('#sliderContent').classList.remove('active');
    document.querySelector("#slider").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));


(function () {
  const links = document.querySelectorAll('#headerNav a.soloLink');

  const normalizePath = (p) =>
    p
      .replace(/^\/[a-z]{2}(?:-[A-Z]{2})?\//, "/") // drop /en/, /is/, /en-GB/, ...
      .replace(/\/$/, "");                         // drop trailing slash

  // current page (pathname only)
  const current = normalizePath(location.pathname);

  links.forEach((a) => {
    const href = a.getAttribute("href");
    if (!href) return;

    // Parse href and take ONLY pathname (ignores ?variant=...)
    const targetPathname = new URL(href, location.origin).pathname;
    const target = normalizePath(targetPathname);

    if (current === target || current.startsWith(target)) {
      const item = a.closest(".headerNavLink");
      if (item) item.classList.add("is-active");
      a.classList.remove("is-active"); // if you were using the anchor class before
    }
  });
})();
